export const contactData = {
  phoneNumber: '0333 577 0767',
  email: 'main@absolutetranslations.com',
  policy: 'https://www.absolutetranslations.com/privacy-policy',
  copyright: `© ${new Date().getFullYear()} Absolute Translations Ltd.| Registered No. 05078111 | VAT Registered No. 775 9220 00 | `,
  data: [
    { name: 'London (Head Office)', phone: '020 8563 2068' },
    { name: 'Manchester', phone: '0161 444 7987' },
    { name: 'Birmingham', phone: '0121 223 0022' },
    { name: 'France', phone: '+33 8 05 11 96 82' },
    { name: 'Germany', phone: '+49 800 723 6189' },
    { name: 'Spain', phone: '+34 91 198 98 48' },
    { name: 'Portugal', phone: '+351 800 181 511' },
  ],
  moreComplexNeeds: 'More complex needs?',
  moreComplexNeedsDescription:
    'Complete the form above and reply to the email we send you with your quote, or contact us direcly by phone or email.',
};
